
;
define("bootstrap", ["jquery","jquery.ui","jquery.migrate","jquery.tagsinput","modernizr","sly","jquery.wholly","animate"], function(){});
